import { DialogContent } from '@mui/material'
import clsx from 'clsx'
import { useState } from 'react'
import StyledDialog from '@Components/Dialog/Dialog'
import CustomModal from '@Components/Modal/CustomModal/CustomModal'
import './my-account.scss'
import SuccessLayout from '@Components/Dialog/SuccessLayout'

// models section
interface IModal {
    open: boolean
    onClose: () => void
}

const PaymentSuccess = (props: IModal) => {
    // core section
    const { open, onClose } = props

    // main
    return (
        <StyledDialog
            fullWidth
            maxWidth="xs"
            open={open}
            onClose={() => onClose()}
        >
            <DialogContent className="p-0 text-center pb-2">
                <SuccessLayout />
                <div className="mt-4">
                    <p className="text-center">
                        Your amount $147.99 was paid
                        <br /> Thank you!
                    </p>
                    <button
                        type="button"
                        className="btn-in-modal w-75 mb-2 mt-4"
                    >
                        Print Statement
                    </button>
                    <button type="button" className="btn-in-modal w-75">
                        Print Receipt
                    </button>
                </div>
                <div className="modal-footer border-0 mt-2">
                    <button
                        type="button"
                        className="btn-no-bg modal-action main-text text-center m-auto"
                        onClick={() => onClose()}
                    >
                        Done
                    </button>
                </div>
            </DialogContent>
        </StyledDialog>
    )
}

// dummy data
const gunlist = [
    {
        id: '#006677',
        name: 'Glock-G19',
        make: 'Glock',
        model: 'G19',
        dueDate: 'Feb 20, 2022',
        paidDate: 'Feb 20, 2021',
        fee: '$220',
        balance: ' - ',
        imageUrl: require('@Images/guns/glock-g19.png').default,
    },
    {
        id: '#008517',
        name: 'Kalashnikov AK47',
        make: 'Kalashnikov',
        model: 'AK47',
        dueDate: 'Feb 20, 2022',
        paidDate: 'Feb 20, 2021',
        fee: '$220',
        balance: ' - ',
        imageUrl: require('@Images/guns/Kalashnikov-AK47.png').default,
    },
    {
        id: '#006677',
        name: 'Glock-G19',
        make: 'Glock',
        model: 'G19',
        dueDate: 'Feb 20, 2022',
        paidDate: 'Feb 20, 2021',
        fee: '$220',
        balance: ' - ',
        imageUrl: require('@Images/accessories/Kalashnikov-AK47.png').default,
    },
]

function ReviewAndConfirmModal(props: IModal) {
    // core section
    const { open, onClose } = props

    // states section
    const [showSuccessModal, setShowSuccessModal] = useState(false)

    // main
    return (
        <>
            <CustomModal
                onClose={() => onClose()}
                open={open && open}
                modalTitle="Review and Confirm"
                modalType="review"
            >
                <div className="modal-body p-0">
                    {gunlist.map((item, i) => {
                        return (
                            <div
                                key={item?.id}
                                className={clsx(
                                    'd-flex pb-2 mb-2 px-2',
                                    gunlist.length - 1 !== i
                                        ? 'page-border-bottom'
                                        : ''
                                )}
                            >
                                <div className="page-img-mini-box page-img-box mr-4">
                                    <img src={item.imageUrl} alt="" />
                                </div>
                                <div>
                                    <p className="main-text font-weight-bold m-0">
                                        {item.name}
                                    </p>
                                    <span className="dark-gray-text">
                                        {item?.id}
                                    </span>
                                </div>
                                <div className="ml-auto">{item?.fee}.00</div>
                            </div>
                        )
                    })}
                    <div className="">
                        <div className="gray-bg d-flex justify-content-between align-items-center py-1">
                            <p className="dark-gray-text m-0">Total Price</p>
                            <span className="black-text font-weight-bold fs-20">
                                $490.00
                            </span>
                        </div>
                    </div>
                </div>
                <div className="modal-footer mt-3">
                    <button
                        type="button"
                        className="btn-no-bg modal-action main-text text-center m-auto"
                        onClick={() => {
                            onClose()
                            setShowSuccessModal(true)
                        }}
                    >
                        Confirm and Pay Now
                    </button>
                </div>
            </CustomModal>
            <PaymentSuccess
                open={showSuccessModal}
                onClose={() => {
                    setShowSuccessModal(false)
                }}
            />
        </>
    )
}

export default ReviewAndConfirmModal
